import styled from '@emotion/styled';

import { Grid } from "@mui/material";


import { BasicFlex } from '../../../utils/Common'

import { useFormikContext } from 'formik';

import Field from '../../../utils/FormikFields/Field';



const PricingDisplay = styled(BasicFlex)`
  color: ${props => props.theme.colors.mildText};
  font-size: 1.2rem;
  font-weight: 500;
  margin-top: .3rem;
`

const SEGMENT_SIZE = 150;
const PRICE_PER_SEGMENT = 0.01;

// Common pasted (Word/Notes/iMessage) chars that look fine but aren't GSM-7.
// Replaced silently; intentional characters like emojis are left untouched.
const SMART_REPLACEMENTS = {
  '\u2018': "'", '\u2019': "'",   // ' '  curly single quotes
  '\u201C': '"', '\u201D': '"',   // " "  curly double quotes
  '\u2013': '-', '\u2014': '-',   // – —  en / em dash
  '\u2026': '...',                // …    ellipsis
  '\u00A0': ' ',                  //      non-breaking space
  '\u2022': '*',                  // •    bullet
};

// Swap only the accidental smart-punctuation; leave everything else as-is.
const normalizeSmartChars = (str = "") =>
  [...str].map((ch) => SMART_REPLACEMENTS[ch] ?? ch).join("");

const MessagePricing = () => {

  const { values } = useFormikContext();

  const chars = values?.text?.length || 0;

  const segments = chars === 0 ? 0 : Math.ceil(chars / SEGMENT_SIZE);

  const cost = (segments * PRICE_PER_SEGMENT).toFixed(2);

  // next bump happens at the first char past the current segment boundary
  const nextBumpAt = segments * SEGMENT_SIZE + 1;
  const charsUntilBump = nextBumpAt - chars;
  const nextCost = ((segments + 1) * PRICE_PER_SEGMENT).toFixed(2);

  let changeHandler = (e) => {
    const cleaned = normalizeSmartChars(e.target.value);
    e.target.value = cleaned;
  }

  return (
    <Grid size={{ xs: 12 }}>
      <div>
        <Field label="Message Body (This will be sent to all customers)" name="text" type="text" formFieldType="text" multiline={true} rows={5} changeHandler={changeHandler} />
      </div>
      <PricingDisplay justify="flex-start" gap=".5rem">
        <p>
          {chars} character{chars === 1 ? '' : 's'} · ${cost} per recipient
        </p>
        {chars > 0 && (
          <p style={{ opacity: 0.7 }}>
            ({charsUntilBump} more until ${nextCost})
          </p>
        )}
      </PricingDisplay>
    </Grid>
  );

};

export default MessagePricing; 

